module.exports = __webpack_public_path__ + "img/432.2f62186a.jpg";